import styled from 'styled-components';

export const LogoContainer = styled.img`
  background: var(--indigo);
  width: 55px;
  height: 55px;
`;
